// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"1869":"styles","3635":"RouteHome","8555":"ComponentFeedResources"}[chunkId] || chunkId) + ".css";
};